import Vue from 'vue/dist/vue.esm.js'
import Select2Mixin from '../../mixins/select2_mixin.js.coffee'
import Select2RemoteMixin from '../../mixins/select2_remote_mixin.js.coffee'

AssociatedDocument = {
  template: JST['report_documents/associated_document_item']()
  props: ['autocompleteUrl', 'hashKey', 'documentAssociation']
  data: ->
    name: 'report_document[document_associations_attributes]'
    deleted: false
  components:
    associatedDocumentSelect: Select2RemoteMixin
  methods:
    nameWithKey: (parameter = null) ->
      if parameter
        "#{@name}[#{@hashKey}][#{parameter}]"
      else
        "#{@name}[#{@hashKey}]"
    idWithKey: (parameter = null) ->
      name = @name[0..-2].
        replace('][', '_').
        replace(']', '_').
        replace('[', '_')
      "#{name}_#{parameter}"
    markAsDeleted: (e) ->
      e.preventDefault()
      @deleted = true
}

Vue.component('associated-documents-block',
  template: JST['report_documents/associated_documents_block']()
  props: ['initialAssociatedDocuments', 'autocompleteUrl', 'documentClusters', 'reportDocumentId']
  data: ->
    associatedDocuments: []
    associatedProcDocuments: []
    selectedDocumentClusterId: null

  beforeMount: ->
    initial_set = @initialAssociatedDocuments
    if initial_set.length > 0
      @associatedDocuments = initial_set
    @fetchProcurementDocuments()

  computed:
    emptyDocument: ->
      {display_name: '', id: '', associated_document_id: ''}
    documentClustersForSelect: ->
      _.map(@documentClusters, (c) -> [c.name, c.id])
  methods:
    randomKey: ->
      _.uniqueId()

    addAssociatedDocument: (e)->
      e.preventDefault()
      @associatedDocuments.push(@emptyDocument)

    fetchProcurementDocuments: ->
      $.ajax
        url: "/admin/report_documents/#{@reportDocumentId}.json"
        method: 'GET'
        success: (data) =>
          @associatedProcDocuments = data.procurement_documents

    addClusterDocuments: (e) ->
      e.preventDefault()
      $.ajax({
        url: "/admin/document_clusters/#{@selectedDocumentClusterId}.json",
        method: "GET",
        success: (data) =>
          _.each(data, (d) =>
            if _.filter(@initialAssociatedDocuments.concat(@associatedDocuments), {associated_document_id: d.associated_document_id}).length == 0
              @associatedDocuments.push(d)
          )
      })

  components:
    associatedDocument: AssociatedDocument
    selectTwoSelect: Select2Mixin
)
